export const scrollUp = () => {
    console.log("word4")
    if (window.pageYOffset !== 0) {
        window.scrollTo(0, 0);
    }
}




// WEBPACK FOOTER //
// ./src/components/functions/functions.js